export default {
  SET_ACCOUNT_DATA(state, params) {
    state.gridData = params;
  },
  SET_ACCOUNT_INFO(state, params) {
    state.accountInfo = params;
  },
  SET_ROOT_ACCOUNT_DATA(state, params) {
    state.rootGridData = params;
  },
  SET_ROOT_ACCOUNT_INFO(state, params) {
    state.rootAccountInfo = params;
  },
};



// WEBPACK FOOTER //
// ./src/vuex/accountManagement/accountRequest/accountRequestMutation.js